<span
  [innerHTML]="'APP.DISCLAIMER' | translate"
  class="text is-tiny"></span>
